<template>
	<div class="xs-12 p4">

		<div class="flex wrap xs-12 mt6">
			<div class="xs-12 md-6 md-pr2">
				<core-form-input
					componentName="j-base-select"
					name="code"
					:options="options.loadingCodes"
					:label="$t('loading_code')"
					v-model="code"
				/>
			</div>
			<div class="xs-12 md-6 md-pr2">
				<core-form-input
					componentName="j-base-input-text"
					name="name"
					:label="$t('name')"
					v-model="name"
				/>
			</div>
		</div>
		<div class="flex wrap xs-12 mt6">
			<div class="xs-12 md-6 md-pr2">
				<core-form-input
					componentName="j-base-select"
					name="type"
					:options="options.type"
					:label="$t('type')"
					v-validate="'required'"
					v-model="type"
					:validationErrors="errors"
				/>
			</div>
			<div class="flex xs-12 md-6 md-pl2 mt6 md-mt0">
				<div
					:class="[{ 'xs-11': type === 'ratio' }, { 'xs-12': type === 'flat' }]"
				>
					<core-form-input
						componentName="j-base-input-number"
						name="amount"
						:label="$t('amount')"
						v-validate="'required'"
						v-model="amount"
						:validationErrors="errors"
					/>
				</div>
				<!-- If ratio show percentage -->
				<div class="flex xs-center xs-middle xs-1 pt6" v-if="type === 'ratio'">
					%
				</div>
			</div>

			<!-- Order -->
			<div class="xs-12 mt6">
				<core-form-input
					componentName="j-base-input-number"
					name="order"
					:label="$t('order')"
					v-model="order"
				/>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * This component is responsible for creation of premium loading
 * Premium loading can be added on offer or directly on policy
 * It's a smart component calling APIs
 */
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import get from "lodash.get"

export default {
	components: {
		CoreFormInput,
		JButton
	},

	props: {
		value: Object
	},

	data() {
		return {
			// When saving is in progress
			isLoading: false,

			productId: null,

			// Form payload
			code: null,
			order: 0,
			name: "",
			amount: 0,
			type: "ratio", // flat or ratio

			// Options for select boxes
			options: {
				type: [
					{ name: this.$t("percentage"), value: "ratio" },
					{ name: this.$t("flat"), value: "flat" }
				],
				loadingCodes: []
			}
		}
	},

	methods: {
		async fetchLoadingSettings() {
			const query = gql`
				query loadingSettings($where: productWhereInput) {
					products_2(where: $where) {
						list {
							loadingSettings {
								codeNames {
									code
									name
								}
							}
						}
					}
				}
			`

			const res = await api({
				query,
				variables: { where: { productId: this.productId } }
			})

			// Process codes
			const codes = get(
				res,
				"data.products_2.list[0].loadingSettings.codeNames",
				[]
			)
			if (!codes) return

			// Prepare it for select box
			this.options.loadingCodes = codes.map(item => ({
				name: `${item.name}`,
				value: item.code
			}))
		}
	},

	watch: {
		code(newValue) {
			if (newValue) {
				this.$emit("input", {
					...this.value,
					code: newValue
				})
			}
		},
		name(newValue) {
			if (newValue) {
				this.$emit("input", {
					...this.value,
					name: newValue
				})
			}
		},
		order(newValue) {
			if (newValue) {
				this.$emit("input", {
					...this.value,
					order: newValue
				})
			}
		},
		amount(newValue) {
			if (newValue) {
				this.$emit("input", {
					...this.value,
					amount: newValue
				})
			}
		},
		type(newValue) {
			if (newValue) {
				this.$emit("input", {
					...this.value,
					type: newValue
				})
			}
		}
	},

	created() {
		this.productId = this?.value?.productId
		this.$emit("input", {
			...this.value,
			order: this.order,
			amount: this.amount,
			type: this.type
		})
		this.fetchLoadingSettings()
	}
}
</script>
